export const BUCKET_SIZES = ["day", "week", "month"] as const;
export type BucketSize = (typeof BUCKET_SIZES)[number];

export interface ConsumptionBucket {
  periodStart: string;
  credits: number;
  endingBalance: number;
}

export interface Overdraft {
  usable: number;
  used: number;
  limit: number | null;
  unlimited: boolean;
}

export interface ConsumptionReport {
  // False when the credit ledger is not provisioned for the account; when
  // false the balance/bucket figures are omitted by the API and default to 0.
  available: boolean;
  startingBalance: number;
  currentBalance: number;
  // Usable credits remaining in the prepaid (provisioned) pool. `currentBalance`
  // is this plus any usable overdraft.
  provisionedBalance: number;
  totalConsumed: number;
  // True once the account has drawn on overdraft (billed as overage).
  inOverdraft: boolean;
  overdraft: Overdraft;
  buckets: ConsumptionBucket[];
}
